module.exports = __webpack_public_path__ + "static/media/page04_two_girls.4f5808c7.gif";